export default __webpack_public_path__ + "static/media/hms-1.6f3f2762.jpg";